<template>
    <div class="tw:hidden tw:xl:flex tw:items-center tw:gap-x-4" />
</template>

<script>
export default {
    name: 'CorporateAdminTopbarLinks',
};
</script>
